import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';

import { getSubjects, getSubjectsName } from '../queries';
import { globalConst } from '..';

export function useSubjectsData(props?: { isNotAll?: boolean }) {
  const t = useTranslations();
  const { data, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.SUBJECTS_DATA],
    queryFn: getSubjects,
    select: ({ subjects }) => ({
      subjects: {
        subject: props?.isNotAll
          ? subjects?.subject
          : [
              {
                id: -1,
                name: t('barchasi'),
                color: '#9B4CAF',
                image: '/images/subject-barchasi.webp'
              },
              ...(subjects?.subject || [])
            ]
      }
    })
  });

  return { ...data, ...args };
}

export function useSubjectsName() {
  const { data, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.SUBJECTS_NAME],
    queryFn: getSubjectsName
  });

  return { ...data, ...args };
}
